import { render, staticRenderFns } from "./CustomerDebt.vue?vue&type=template&id=90f45712&"
import script from "./CustomerDebt.vue?vue&type=script&lang=js&"
export * from "./CustomerDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports